import React from "react";
import { useNavigate } from "react-router-dom";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import { FAMA_SUPPORT_EMAIL } from "../utils";

export const Unauthorized = () => {
  const navigate = useNavigate();
  function handleNavigate() {
    navigate(`/reports`);
  }
  const mailto = `mailto:${FAMA_SUPPORT_EMAIL}`;
  return (
    <div data-testid="unauthorized">
      <div className="flex flex-col gap-6 justify-center items-center pt-4">
        <div className="w-96">
          <img
            src="/invalid_request.svg"
            alt="Invalid Request"
            className="w-full"
          />
        </div>
        <p className="text-5xl font-bold">Invalid Request</p>
        <p className="text-xl text-stone-800">
          Please contact
          <a href={mailto} className="underline mx-2">
            {FAMA_SUPPORT_EMAIL}
          </a>
          for assistance.
        </p>
        <p>
          <Button
            text="Go Back to reports"
            colorType={ButtonColorTypes.success}
            onClick={handleNavigate}
          />
        </p>
      </div>
    </div>
  );
};
